import { useEffect, useState } from "react";
import axios from "axios";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Landmark } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * CongressSelector, small, reusable dropdown that lists the supported
 * Congresses (fetched from /api/congresses) and calls onChange(number) when
 * the user picks one.
 */
export default function CongressSelector({ value, onChange, testId = "congress-selector" }) {
  const [options, setOptions] = useState([]);

  useEffect(() => {
    let cancelled = false;
    axios
      .get(`${API}/congresses`, { timeout: 15000 })
      .then((r) => {
        if (!cancelled) setOptions(r.data?.congresses || []);
      })
      .catch(() => {
        // Fallback list so the UI never breaks if the endpoint is slow
        if (!cancelled) {
          setOptions([
            { number: 119, label: "119th Congress", years: "2025-2027", session: "current" },
            { number: 118, label: "118th Congress", years: "2023-2025", session: "historical" },
            { number: 117, label: "117th Congress", years: "2021-2023", session: "historical" },
            { number: 116, label: "116th Congress", years: "2019-2021", session: "historical" },
          ]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <div className="flex items-center gap-2" data-testid={testId}>
      <Landmark className="w-4 h-4 text-gray-500" />
      <Select value={String(value)} onValueChange={(v) => onChange(parseInt(v, 10))}>
        <SelectTrigger className="w-full sm:w-auto sm:min-w-[200px]" data-testid={`${testId}-trigger`}>
          <SelectValue placeholder="Select Congress" />
        </SelectTrigger>
        <SelectContent>
          {options.map((c) => (
            <SelectItem key={c.number} value={String(c.number)} data-testid={`${testId}-opt-${c.number}`}>
              {c.label} · {c.years}
              {c.session === "current" ? " (current)" : ""}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
